import {useDispatch, useSelector} from 'react-redux'
import {RouteComponentProps} from 'react-router-dom'
import RoutineForm from 'src/components/RoutineForm'
import Routine from 'src/models/Routine'
import {RootState} from 'src/redux/rootReducer'
import {useState} from 'react'
import {useEffect} from 'react'
import {ActionSelectors, ActivitySelectors, GoalSelectors} from 'src/redux/selectors'
import {actions as routinesActions} from 'src/redux/modules/routines'
import {actions as actionsActions} from 'src/redux/modules/actions'

export type RoutineCreateProps = RouteComponentProps & {}

const {selectActions} = ActionSelectors
const {selectActivities} = ActivitySelectors
const {selectGoals} = GoalSelectors

const RoutineCreate: React.FC<RoutineCreateProps> = ({history}: RoutineCreateProps) => {
  const [isSaving, setIsSaving] = useState<Boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const {dataState} = useSelector((state: RootState) => state.routines)
  const actionsState = useSelector((state: RootState) => state.actions)
  const allActions = useSelector(selectActions)
  const allActivities = useSelector(selectActivities)
  const allGoals = useSelector(selectGoals)

  const dispatch = useDispatch()

  const onSaveRoutine = (updatedRoutine: Routine, imageFile: File | undefined) => {
    // Save the Routine.
    dispatch(routinesActions.saveRoutine({routine: updatedRoutine, imageFile: imageFile}))

    // Set the flag
    setIsSaving(true)
  }

  const onCancelRoutine = () => {
    // Back to the routines page.
    history.goBack()
  }

  useEffect(() => {
    if (isSaving && dataState.state !== 'loading') {
      // Finished saving.
      setIsSaving(false)

      if (!dataState.error) {
        // And no error!
        setIsSuccess(true)
      }
    }
  }, [isSaving, dataState, history])

  if (actionsState.dataState.state === 'unloaded') {
    // We need to load the actions.
    dispatch(actionsActions.getAllActions())
  }

  const busyString = isSaving
    ? 'Saving Routine...'
    : actionsState.dataState.state === 'loading' || dataState.state === 'loading'
    ? 'Loading routines & actions...'
    : undefined

  const successString = isSuccess ? 'Routine Created!' : undefined

  return (
    <RoutineForm
      onSaveRoutine={onSaveRoutine}
      onCancel={onCancelRoutine}
      onDismissSuccess={() => history.goBack()}
      title="Create New Routine"
      allActions={allActions}
      allActivities={allActivities}
      allGoals={allGoals}
      busyString={busyString}
      successString={successString}
      errorMessage={dataState.error?.message}
    />
  )
}

export default RoutineCreate
